import { type Control, useFormState, useWatch } from 'react-hook-form';
import { Stack, Grid, Typography, Divider, Box } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';

import { type EditAuditFormBackgroundData } from '#apps/client-web/pages/audit-form-background/types';

import { isNil } from '#packages/data-collection/libs/lodash';

export type AddressDetailsProps = {
  control: Control<EditAuditFormBackgroundData>;
};

export const AddressDetails = ({ control }: AddressDetailsProps) => {
  const { errors } = useFormState({
    control,
  });

  const {
    general: { address } = {
      address: {},
    },
  } = useWatch({
    control,
  });

  return (
    <Box sx={{ width: '100%' }}>
      <Stack spacing={1}>
        <Typography
          component="div"
          variant="body2"
          color="textSecondary"
          sx={{ mb: 0.5 }}>
          <Grid container alignItems="center">
            <LocationOnIcon fontSize="inherit" />
            <span>&nbsp;Address</span>
          </Grid>
        </Typography>
        <Typography component="div" variant="body2" sx={{ textAlign: 'start' }}>
          <Typography
            variant="inherit"
            component="span"
            color={
              errors.general?.address?.addressLine1
                ? 'error'
                : isNil(address?.addressLine1)
                  ? 'textDisabled'
                  : 'primaryText'
            }>
            {address?.addressLine1 ?? 'Address'},{' '}
          </Typography>
          <Typography
            variant="inherit"
            component="span"
            color={
              errors.general?.address?.city
                ? 'error'
                : isNil(address?.city)
                  ? 'textDisabled'
                  : 'primaryText'
            }>
            {address?.city ?? 'City'},{' '}
          </Typography>
          <Typography
            variant="inherit"
            component="span"
            color={
              errors.general?.address?.state
                ? 'error'
                : isNil(address?.state)
                  ? 'textDisabled'
                  : 'primaryText'
            }>
            {address?.state ?? 'State/Province'},{' '}
          </Typography>
          <Typography
            variant="inherit"
            component="span"
            color={
              errors.general?.address?.postalCode
                ? 'error'
                : isNil(address?.postalCode)
                  ? 'textDisabled'
                  : 'primaryText'
            }>
            {address?.postalCode ?? 'Postal Code'}
          </Typography>
        </Typography>
        <Divider />
      </Stack>
    </Box>
  );
};
